import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faFilter, faCheck, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
// import { SharedRankingListService } from '../shared-ranking-list/shared-ranking-list.service';

@Component({
    selector: 'app-shared-clean-filter',
    templateUrl: './shared-clean-filter.component.html',
    styleUrls: ['./shared-clean-filter.component.scss'],
})
export class SharedCleanFilterComponent implements OnInit {
    @Input() storageKey = 'app-filters'; // Allow customization per instance
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    @Output() onConfirm: EventEmitter<any> = new EventEmitter();

    collapse = {};

    icons = {
        filter: faFilter,
        check: faCheck,
        caretRight: faCaretRight,
    };

    modal: NbDialogRef<unknown>;

    /**
     * filterList -
     * Lista de filtros para montagem do HTML
     */
    filterList = [];

    /**
     * selectedFilters -
     * Stores current selected filters internally
     */
    selectedFilters: { [key: string]: any } = {};

    constructor(private modalService: NbDialogService) { }

    ngOnInit(): void {

    }

    @Input('filter') set filter(filters) {
        if (!filters) return; //filters é undefined antes do recebimento da api
        this.filterList = [...(filters ?? [])];
        this.hideCollapses();
        this.initializeSelectedFilters();
    }

    /**
     * Faz com que o collapse apareça fechado.
     *
     * collapse está verificando quem está
     * aberto/fechado através do index.
     *
     * O código abaixo mapea todos os index
     * para true, que indica que o collapse está ativo,
     * o conteúdo está oculto
     *
     * !collapse é um objeto, não confundir com array
     * ex da estrutura final:
     * collapse {
     *  0: true,
     *  1: true
     * }
     */
    private hideCollapses() {
        for (let index in Array.from(Array(this.filterList.length))) {
            this.collapse[index] = true;
        }
    }

    getCheckboxValues(filter: any) {
        const selectedCheckbox = filter.options.filter((checkbox) => checkbox.selected);
        const arrOfCheckboxValues = selectedCheckbox.reduce((acc, cur) => [...acc, cur.id], []);
        return arrOfCheckboxValues;
    }

    /**
     * TODO: Melhorar documentação e explicar necessidade
     * de tudo que acontece aqui ou sugerir mudança na API
     */
    onChangeEvt(event) {
        const { value, checked } = event.target;

        const filterId = event.target.getAttribute('data-filter');

        const filterIndexToModifySelected = this.filterList.findIndex((filterItem) => {
            return filterItem.id === filterId;
        });

        const filterData = this.filterList[filterIndexToModifySelected];

        const filter = this.filterList[filterIndexToModifySelected].options.find((option) => option.value == value);

        if (filterData.type === 2) {
            // Checkbox: manage array of selections
            const filterGroup = this.filterList[filterIndexToModifySelected].options;
            const optionIndexToSelect = filterGroup.findIndex((option) => option.value === filter.value);

            if (checked) {
                filterGroup[optionIndexToSelect].selected = 1;
            } else {
                filterGroup[optionIndexToSelect].selected = 0;
            }

            this.filterList[filterIndexToModifySelected].options = filterGroup;

            // Update selectedFilters
            const selectedValues = this.getCheckboxValues(filterData);
            if (selectedValues.length > 0) {
                this.selectedFilters[filterId] = selectedValues;
            } else {
                delete this.selectedFilters[filterId];
            }
        } else {
            console.log('radio selected:', filter.value, filterId, this.filterList[filterIndexToModifySelected].options);
            // Radio: single selection
            this.filterList[filterIndexToModifySelected].options.map(
                (option) => (option.selected = option.id === filter.value)
            );

            // Update selectedFilters
            this.selectedFilters[filterId] = filter.value;
        }
        console.log(this.selectedFilters);
        this.saveFiltersToStorage();
        this.onChange.emit(this.getSelectedFilters());
    }

    onFilterBtnClick() {
        // Emit selected filters to parent and close modal
        this.saveFiltersToStorage();
        this.onConfirm.emit(this.getSelectedFilters());
        this.modal.close();
    }

    getKey(filter) {
        // Retorno ex: Objeto 1: [ranking_model], Objeto2: [rating_date];

        return this.filterList.findIndex((item) => item === filter);
    }

    openModal(content) {
        this.modal = this.modalService.open(content);
    }

    closeModal() {
        this.modal.close();
    }

    getHeader(filter) {
        const key = this.getKey(filter);
        return filter[key].label;
    }

    /**
     * initializeSelectedFilters()
     * Reads current selected values from filterList
     */
    private initializeSelectedFilters() {
        this.selectedFilters = this.restoreStoredFilters();

        if (Object.keys(this.selectedFilters).length > 0) {
            return;
        }
    }

    /**
     * clearAllFilters()
     * Clears all filter selections
     */
    clearAllFilters() {
        this.filterList.forEach((filter) => {
            filter.options.forEach((option) => {
                option.selected = filter.type === 2 ? 0 : false;
            });
        });

        this.selectedFilters = {};
        this.clearStoredFilters();
    }

    /**
     * getSelectedFilters()
     * Returns current selected filters without emitting
     */
    getSelectedFilters() {
        return { ...this.selectedFilters };
    }

    /**
     * hasActiveFilters()
     * Returns true if any filters are selected
     */
    hasActiveFilters(): boolean {
        return Object.keys(this.selectedFilters).length > 0;
    }

    /**
     * saveFiltersToStorage()
     * Saves current filters to localStorage
     */
    private saveFiltersToStorage(): void {
        try {
            localStorage.setItem(this.storageKey, JSON.stringify(this.selectedFilters));
        } catch (e) {
            console.warn('Error saving filters to localStorage:', e);
        }
    }

    /**
     * loadStoredFilters()
     * Loads filters from localStorage
     */
    private loadStoredFilters(): any {
        try {
            const stored = localStorage.getItem(this.storageKey);
            return stored ? JSON.parse(stored) : {};
        } catch (e) {
            console.warn('Error loading filters from localStorage:', e);
            return {};
        }
    }

    /**
     * restoreStoredFilters()
     * Applies stored filters to the current filterList
     */
    private restoreStoredFilters() {
        const storedFilters = this.loadStoredFilters();
        if (!storedFilters || Object.keys(storedFilters).length === 0) {
            return {};
        }

        this.filterList.forEach((filter) => {
            const storedValue = storedFilters[filter.id];
            if (!storedValue) {
                return;
            }

            if (filter.type === 2) {
                // Checkbox: restore array of selections
                if (Array.isArray(storedValue)) {
                    filter.options.forEach((option) => {
                        option.selected = storedValue.includes(option.value) ? 1 : 0;
                    });
                }
            } else {
                // Radio: restore single selection
                const optionExists = filter.options.some((option) => option.value === storedValue);
                if (optionExists) {
                    filter.options.forEach((option) => {
                        option.selected = option.value === storedValue;
                    });
                }
            }
        });

        return storedFilters;
    }

    /**
     * clearStoredFilters()
     * Removes filters from localStorage
     */
    private clearStoredFilters(): void {
        try {
            localStorage.removeItem(this.storageKey);
        } catch (e) {
            console.warn('Error clearing filters from localStorage:', e);
        }
    }

}
